const TOKEN_KEY = 'fistakip.token';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string | null) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

const BASE = import.meta.env.VITE_API_URL ?? '';

function url(path: string) {
  return `${BASE}${path}`;
}

async function parseOrThrow(res: Response) {
  const ct = res.headers.get('Content-Type') ?? '';
  if (!res.ok) {
    let message = 'Bir hata oluştu';
    if (ct.includes('application/json')) {
      const data = await res.json().catch(() => null);
      message = (data as { error?: string } | null)?.error ?? message;
    }
    throw new Error(message);
  }
  if (ct.includes('application/json')) return res.json();
  return res;
}

export async function apiGet<T>(path: string): Promise<T> {
  const token = getToken();
  const res = await fetch(url(path), {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return (await parseOrThrow(res)) as T;
}

export async function apiPost<T>(path: string, body: unknown): Promise<T> {
  const token = getToken();
  const res = await fetch(url(path), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
  });
  return (await parseOrThrow(res)) as T;
}

export async function apiPostForm<T>(path: string, form: FormData): Promise<T> {
  const token = getToken();
  const res = await fetch(url(path), {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });
  return (await parseOrThrow(res)) as T;
}

export async function apiDownload(path: string, filename: string): Promise<void> {
  const token = getToken();
  const res = await fetch(url(path), {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error('İndirme başarısız');
  const blob = await res.blob();
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(a.href);
}

export function authedImageUrl(path: string): string {
  return url(path);
}

export async function apiPatch<T>(path: string, body: unknown): Promise<T> {
  const token = getToken();
  const res = await fetch(url(path), {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
  });
  return (await parseOrThrow(res)) as T;
}
